import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ChangePasswordPage from "../ChangePasswordPage";

function ChangePasswordRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          direction: "rtl",
        }}
      >
        <p style={{ color: "var(--brand-primary)", fontSize: "16px" }}>جاري التحميل...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.mustChangePassword) {
    return <Navigate to="/" replace />;
  }

  return <ChangePasswordPage />;
}

export default ChangePasswordRoute;
